import type { FC, ReactNode } from 'react';

import { CodeChip } from '../../../components/reusable/code-chip';
import { CardItems } from '../../../components/reusable/components';
import type { IStateSummary } from './utils';

interface IDdRow {
	title: string;
	value: string | number;
	action?: () => void;
	renderValue?: ReactNode;
}

export const StateSummary: FC<IStateSummary> = ({ stateData, rightPanel }) => {
	const metaData = stateData?.data;
	if (!metaData) return <></>;
	const ddata: IDdRow[] = metaData
		? [
				{
					title: 'State Code',
					value: metaData.stateCode,
					renderValue: (
						<CodeChip
							code={metaData.stateCode}
							level='state'
							peek={false}
						/>
					),
				},
				{
					title: 'State',
					value: metaData.name,
				},
				{
					title: 'Geographic Zone',
					value: metaData.geographicalZone.name,
				},
				{
					title: 'Total No. of Constituencies',
					value: metaData.constituencyCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-state',
							title: `Constituencies in ${metaData.name} State`,
							data: {
								id: metaData.id,
								electoralDivision: 'constituency',
							},
						});
					},
				},
				{
					title: 'Local Governments',
					value: metaData.lgaCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-state',
							title: `Local Governments in ${metaData.name} State`,
							data: {
								id: metaData.id,
								electoralDivision: 'lga',
							},
						});
					},
				},
				{
					title: 'Polling Units',
					value: metaData.pollingUnitCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-state',
							title: `Polling Units in ${metaData.name} State`,
							data: {
								id: metaData.id,
								electoralDivision: 'pollingunit',
							},
						});
					},
				},
				{
					title: 'RA/Wards',
					value: metaData.wardCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-state',
							title: `RA/Wards in ${metaData.name} State`,
							data: {
								id: metaData.id,
								electoralDivision: 'ward',
							},
						});
					},
				},
			]
		: [];
	const data = metaData
		? [
				{
					title: 'Description',
					value: metaData.description || 'No data',
				},
			]
		: [];
	return (
		<div className='f-column-33 text-left pt-3'>
			<div className='grid-wrapper-40 gap-30 text-left'>
				{ddata.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i.value.toLocaleString()}
							onHandleClick={i.action}
							renderValue={i.renderValue}
						/>
					</div>
				))}
			</div>
			<div className='f-column-33 text-left'>
				{data.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i.value.toLocaleString()}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
